/* eslint-disable */
import React from "react";
import { last, first } from 'lodash';
import { CalendarYear } from '../../../controls/CalendarYear';
import { useParameter } from "../../../shared";

export const CalendarControl: React.FC = () => {
    const [lastYear] = useParameter("@last_year");
    const set = (value: number[] | null | undefined) => {
         
        return value && last(value);
    };
    const change = (value: number | null | undefined) => {
         
        return value && [value];
    };
    return <CalendarYear lastYear={lastYear} parameter="@calendar" dictionary="calendar-population" onSet={set} onChange={change} />;
};
